import { render, staticRenderFns } from "./RadioGamePeriod.vue?vue&type=template&id=7252685b&scoped=true&"
import script from "./RadioGamePeriod.vue?vue&type=script&lang=js&"
export * from "./RadioGamePeriod.vue?vue&type=script&lang=js&"
import style0 from "./RadioGamePeriod.vue?vue&type=style&index=0&id=7252685b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7252685b",
  null
  
)

export default component.exports